import { axiosClient } from "../../../../library/Service/axiosClient";


const EngagementService = () => {

    async function fetchEngagaementData(userId) {
        const engagementData =
            (await axiosClient().get(
                `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/engagement/user-data/${userId}`
            )) ?? [];

        return engagementData?.data || [];
    }
        
    return {
        fetchEngagaementData
    };
};

export default EngagementService;
